export default "__VITE_ASSET__CIDrW52O__"